export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 items-center">
          <div>
            <div className="inline-block border border-gray-300 text-gray-600 px-3 py-1.5 rounded-full text-xs font-medium mb-4 md:mb-6">
              ABOUT US
            </div>

            <h2 className="text-2xl md:text-5xl font-bold text-slate-800 mb-2 md:mb-4 leading-tight">
              飲食の情熱と
            </h2>
            <h2 className="text-2xl md:text-5xl font-light text-gray-600 mb-5 md:mb-8 leading-tight italic">
              経営の知恵を融合
            </h2>

            <p className="text-sm md:text-lg text-gray-700 leading-relaxed mb-6 md:mb-8">
              私たちは、味噌ラーメン専門店「花木流味噌 五反野店」の運営を通じて培った実践的なノウハウと、経営コンサルティングの専門知識を組み合わせ、飲食業界で挑戦する皆様を支援しています。
            </p>

            <a
              href="#contact"
              className="inline-flex items-center text-sm text-teal-700 font-medium hover:text-teal-800 transition-colors cursor-pointer"
            >
              会社概要を詳しく見る
              <i className="ri-arrow-right-line ml-2"></i>
            </a>

            <div className="mt-8 md:mt-12 grid grid-cols-2 gap-6 md:gap-8">
              <div>
                <div className="text-3xl md:text-5xl font-bold text-slate-800 mb-1">50+</div>
                <div className="text-xs md:text-base text-gray-600">支援店舗数</div>
              </div>
              <div>
                <div className="text-3xl md:text-5xl font-bold text-slate-800 mb-1">15年</div>
                <div className="text-xs md:text-base text-gray-600">業界経験</div>
              </div>
            </div>
          </div>

          <div className="relative hidden lg:block">
            <div className="grid grid-cols-2 gap-6">
              <div className="space-y-6">
                <div className="rounded-2xl overflow-hidden">
                  <div className="h-64 w-full">
                    <img
                      src="https://public.readdy.ai/ai/img_res/6a17a7ca44cb15e5817aae832219f290.jpg"
                      alt="料理人"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>
              </div>
              <div className="space-y-6 mt-12">
                <div className="rounded-2xl overflow-hidden">
                  <div className="h-80 w-full">
                    <img
                      src="https://readdy.ai/api/search-image?query=successful%20japanese%20restaurant%20owner%20and%20business%20consultant%20in%20professional%20attire%20standing%20confidently%20in%20elegant%20dining%20space%20with%20warm%20smile%20and%20welcoming%20atmosphere%20in%20natural%20lighting&width=400&height=600&seq=owner001&orientation=portrait"
                      alt="代表"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 md:mt-24 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8">
          {[
            { icon: 'ri-lightbulb-line', bg: 'bg-teal-100', color: 'text-teal-700', title: '実践的なノウハウ', text: '自社運営の飲食店で培った現場の知識と経験を、コンサルティングに活かします' },
            { icon: 'ri-heart-line', bg: 'bg-amber-100', color: 'text-amber-700', title: '寄り添うサポート', text: 'お客様の課題に真摯に向き合い、長期的なパートナーとして成長を支援します' },
            { icon: 'ri-trophy-line', bg: 'bg-rose-100', color: 'text-rose-700', title: '確かな実績', text: '50店舗以上の支援実績と、多様な業態での成功事例が私たちの強みです' },
          ].map((item) => (
            <div key={item.title} className="flex md:flex-col items-start md:items-center gap-4 md:gap-0 p-4 md:p-8 md:text-center">
              <div className={`w-12 h-12 flex items-center justify-center ${item.bg} rounded-full flex-shrink-0 md:mx-auto md:mb-6`}>
                <i className={`${item.icon} text-2xl ${item.color}`}></i>
              </div>
              <div>
                <h3 className="text-base md:text-xl font-bold text-slate-800 mb-1 md:mb-4">{item.title}</h3>
                <p className="text-xs md:text-base text-gray-600 leading-relaxed">{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
